module.exports = __webpack_public_path__ + "img/francia.af11072d.jpg";